<h2 mat-dialog-title i18n>Welchen Termin möchten Sie beitreten?</h2>
<mat-dialog-content
  ><span i18n
    >Zurzeit sind {{ dataSource.data.length }} Termine offen welche für Sie oder
    keinen anderen Mitarbeiter zugewiesen sind.</span
  >

  <div>
    <table [dataSource]="dataSource" mat-table>
      <ng-container matColumnDef="title">
        <th
          *matHeaderCellDef
          mat-header-cell
          i18n="@@joinOpenAppointmentCaseTitle"
        >
          Falltitel
        </th>
        <td *matCellDef="let element" mat-cell>
          <span
            [class.no-case-title-available]="
              !element.title?.trim() && !element.inquiryCreatedAt
            "
          >
            {{ getCaseTitle(element) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell i18n>Kunde</th>
        <td *matCellDef="let element" mat-cell>
          @if (element.customerPhoneNumber) {
            <span>{{ element.customerPhoneNumber }}</span>
          } @else {
            <span class="no-phone-number-available ns" i18n>Unbekannt</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="scheduledFor">
        <th
          *matHeaderCellDef
          mat-header-cell
          i18n="@@joinOpenAppointmentScheduledFor"
        >
          Termin
        </th>
        <td *matCellDef="let element" mat-cell>
          <app-date-range
            [endDate]="null"
            [startDate]="element.scheduledFor"
          ></app-date-range>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignedEmployeeDisplayName">
        <th *matHeaderCellDef mat-header-cell i18n>Mitarbeiter</th>
        <td *matCellDef="let element" mat-cell>
          {{ element.employee.firstName }} {{ element.employee.lastName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="joinAppointment">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell>
          <button
            (click)="onJoinAppointmentClicked(element)"
            mat-button
            color="primary"
          >
            <span i18n>Beitreten</span>
            <mat-icon class="join-open-appointment-button"
              >arrow_forward</mat-icon
            >
          </button>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>

      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="warn" i18n>Abbrechen</button>
</mat-dialog-actions>
